export class UserSettings {
  signature: string;

  constructor(v: Partial<UserSettings> = {}) {
    Object.assign(this, v);
  }
}
